import axiosInstance from '../configs/axios/interceptors';

const AnomaliesServices = {

    getAnomalies: async (filters, documentCategoryId) => {     
        const params = { anomalyName: filters.anomalyName, isEnabled: filters.isEnabled, categoryID: documentCategoryId}; 
        const response = await axiosInstance.get('Anomalies/GetAnomaliesList', {params: params});
        return response.data;
    },

    createAnomalie: async (payload) => {   
        const response = await axiosInstance.post('Anomalies/AddAnomalies', payload);
        return response.data;
    },

    updateAnomalie: async (payload) => {   
        const response = await axiosInstance.put('Anomalies/UpdateAnomalies', payload);
        return response.data;
    },
    
    deleteAnomalie: async (anomalieId) => {      
        const params = { anomaliesID: anomalieId };
        const response = await axiosInstance.delete('Anomalies/DeleteAnomalies', {params: params});
        return response.data;
    },

};

export default AnomaliesServices;
